import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { tablet768, desktop1024 } from '@nubank/nuds-web/styles/breakpoints';
import { nuDSColor } from '@nubank/nuds-web/styles/themeUtils';

import useInView from '@nubank/www-latam-commons/utils/hooks/useInView';
import addWebpBackgroundImage from 'styles/addWebpBackgroundImage';

const handleBackgroundColor = ({
  backgroundColor,
}) => backgroundColor && css`background-color: ${nuDSColor(backgroundColor)}`;

const handleBackgroundImage = ({
  backgroundImagePath,
  backgroundImagePathMobile,
  backgroundImagePathDesktop,
}) => css`
  ${backgroundImagePathMobile && (addWebpBackgroundImage(backgroundImagePathMobile))};
  ${backgroundImagePath && tablet768`${addWebpBackgroundImage(backgroundImagePath)}`};
  ${backgroundImagePathDesktop && desktop1024`${addWebpBackgroundImage(backgroundImagePathDesktop)}`};
`;

const StyledBackgroundSection = styled.section`
  ${handleBackgroundColor};
  &[data-visible="true"] {
    ${handleBackgroundImage};
  }
`;

function BackgroundSection(props) {
  const {
    children,
    className,
    backgroundColor,
    backgroundImagePath,
    backgroundImagePathMobile,
    backgroundImagePathDesktop,
  } = props;

  const [ref, isVisible] = useInView();

  return (
    <StyledBackgroundSection
      className={className}
      ref={ref}
      data-visible={isVisible}
      backgroundColor={backgroundColor}
      backgroundImagePath={backgroundImagePath}
      backgroundImagePathMobile={backgroundImagePathMobile}
      backgroundImagePathDesktop={backgroundImagePathDesktop}
    >
      {children}
    </StyledBackgroundSection>
  );
}

BackgroundSection.defaultProps = {
  backgroundColor: undefined,
  backgroundImagePath: undefined,
  backgroundImagePathMobile: undefined,
  backgroundImagePathDesktop: undefined,
  className: undefined,
};

BackgroundSection.propTypes = {
  backgroundColor: PropTypes.string,
  backgroundImagePath: PropTypes.string,
  backgroundImagePathDesktop: PropTypes.string,
  backgroundImagePathMobile: PropTypes.string,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default BackgroundSection;
